import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { Link as RouterLink } from 'react-router-dom';
import SwipeActions from './SwipeActions';

import CategoryImage from '../components/CategoryImage';

const Report = props => {
  if (!props.report) {
    return null;
  }

  return (
    <div className="Report-wrapper">
      <SwipeActions reportId={props.report.id}>
        <RouterLink
          className={`Report ${props.read ? 'is-read' : ''}`}
          to={`/reports/${props.report.id}`}
        >
          <div className="Report-icon">
            <CategoryImage read={props.read} category={props.report.categoryIcon} />
          </div>
          <div className="Report-info">
            <h3 className="Report-title">{props.report.title}</h3>
            <div className="Report-meta">
              {props.report.location}, <br />
              {moment(props.report.validFrom, 'DD.MM.YYYY HH:mm:ss').format(
                'DD.MM.YYYY HH:mm [Uhr]',
              )}
            </div>
            <p className="Report-description">{props.report.shortDescription}</p>
          </div>
          {props.read ? (
            <img className="Report-arrow" src="./images/arrow-grey.png" alt="" />
          ) : (
            <img className="Report-arrow" src="./images/arrow.png" alt="" />
          )}
        </RouterLink>
      </SwipeActions>
    </div>
  );
};

Report.propTypes = {
  report: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    location: PropTypes.string,
    validFrom: PropTypes.string,
    validUntil: PropTypes.string,
    shortDescription: PropTypes.string,
    categoryIcon: PropTypes.string,
  }).isRequired,
  read: PropTypes.bool,
};

Report.defaultProps = {
  read: false,
};

export default Report;



// WEBPACK FOOTER //
// ./src/js/components/Report.js